var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type, Expose, Transform, Exclude } from 'class-transformer';
import { KibanaDashboardModel } from './osd-dashboard';
export class KibanaDrilldownModel {
    fieldName = undefined;
    isProtected;
    // When sending to the server, send the dashboard ID taken from the dashboard object attached to the object.
    dashboardId = null;
    // This data isn't coming from the API. It's added with another request, but can come with a JSON dashboard from a
    // form like KibanaDashboardSelect.
    dashboard = undefined;
    // This is helping us workaround the fact that we don't really get an ID, and we return the value of fieldName
    // as the ID.
    get id() {
        return this.fieldName;
    }
}
__decorate([
    Expose({ name: 'protected', toClassOnly: true }),
    __metadata("design:type", Boolean)
], KibanaDrilldownModel.prototype, "isProtected", void 0);
__decorate([
    Transform((value, obj) => obj.dashboard && obj.dashboard.id, { toPlainOnly: true }),
    __metadata("design:type", Object)
], KibanaDrilldownModel.prototype, "dashboardId", void 0);
__decorate([
    Exclude({ toPlainOnly: true }),
    Type(() => KibanaDashboardModel),
    __metadata("design:type", Object)
], KibanaDrilldownModel.prototype, "dashboard", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], KibanaDrilldownModel.prototype, "id", null);
//# sourceMappingURL=osd-drilldown.js.map